module.exports = __webpack_public_path__ + "img/ico-seedling.5134d8bc.svg";